var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.198,
    height: 55.198,
    viewBox: "0 0 55.198 55.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 55.198,
    height: 55.198,
    rx: 26.753,
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(11.323 11.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0.677 0.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1716.933-127.026c-.01.9-.016,2.69-.056,4.477a16.186,16.186,0,0,1-.444,4.025,8.268,8.268,0,0,1-6.688,6.239,16.086,16.086,0,0,1-2.921.289c-3.774.113-7.548.093-11.322.019a17.626,17.626,0,0,1-3.577-.346,8.213,8.213,0,0,1-5.991-4.736,10.123,10.123,0,0,1-.859-3.577c-.2-3.01-.146-6.025-.14-9.039q.006-2.53.108-5.06a10.12,10.12,0,0,1,1.3-4.856,8.211,8.211,0,0,1,5.29-3.87,16.139,16.139,0,0,1,3.849-.406q5.18-.034,10.362-.019a20.928,20.928,0,0,1,3.626.265,8.32,8.32,0,0,1,6.269,4.438,9.776,9.776,0,0,1,1.028,3.8C1716.965-132.9,1716.915-130.4,1716.933-127.026Zm-15.991-14.052v.03c-.561,0-1.121-.005-1.681,0-1.974.02-3.949-.021-5.916.192a6.473,6.473,0,0,0-2.616.812,5.457,5.457,0,0,0-2.616,3.82,18.08,18.08,0,0,0-.271,3.485c-.024,2.9-.021,5.8-.014,8.7a27.476,27.476,0,0,0,.206,3.952,6.171,6.171,0,0,0,1.071,2.811,5.6,5.6,0,0,0,4.121,2.251,34.341,34.341,0,0,0,3.493.194q4.6.028,9.2-.024a25.982,25.982,0,0,0,2.949-.207,5.634,5.634,0,0,0,3.07-1.341,5.686,5.686,0,0,0,1.892-3.835,33.038,33.038,0,0,0,.19-3.432c0-3.521-.03-7.042-.064-10.563a9.4,9.4,0,0,0-.356-2.547,5.3,5.3,0,0,0-3.775-3.811,10.28,10.28,0,0,0-2.725-.377C1705.049-141.013,1702.995-141.042,1700.942-141.078Z",
    transform: "translate(-1684.922 143.893)",
    fill: "#259e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1709.45-126.419a7.007,7.007,0,0,1-7.026,7.008,7.01,7.01,0,0,1-6.994-7.042,7.012,7.012,0,0,1,7.052-6.983A7.009,7.009,0,0,1,1709.45-126.419Zm-2.455,0a4.547,4.547,0,0,0-4.508-4.558,4.541,4.541,0,0,0-4.6,4.515,4.547,4.547,0,0,0,4.54,4.595A4.551,4.551,0,0,0,1707-126.418Z",
    transform: "translate(-1686.436 142.386)",
    fill: "#259e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1715.443-134.259a2.2,2.2,0,0,1,2.227-2.2,2.2,2.2,0,0,1,2.19,2.216,2.217,2.217,0,0,1-2.23,2.206A2.212,2.212,0,0,1,1715.443-134.259Z",
    transform: "translate(-1693.283 141.856)",
    fill: "#259e76"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.94473b35.svg";
export { ForwardRef as ReactComponent };